import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfoMessage from 'components/InfoMessage';
import styles from './innCertificate.module.scss';
import BlueBlock from 'modules/Profile/components/PersonalData/components/BlueBlock';
import moment from 'moment';
import DateFormats from 'constants/DateFormats';
import Button, { BUTTON_COLORS } from 'components/Button';
import { ReactComponent as DownloadIcon } from '../assets/icons-regular-icons-ic-download.svg';
import {
  getLastNotificationCardId,
  getNotificationResponseByCardId,
} from 'modules/Taps/services/API/notification';
import { get } from 'lodash';
import { INN_RESPONSE_NUMBER } from 'modules/Taps/components/InnCertificateRequest/constants';
import DataStatusWrapper from 'components/DataStatusWrapper/DataStatusWrapper';
import Loading from 'components/Loading';
import * as fileSaver from 'file-saver';
import REACT_CONFIG from 'REACT_CONFIG';
import { remotePaths } from 'router/routes';

class InnCertificate extends Component {
  state = {
    loading: true,
    cardId: null,
    pdfLoading: null,
  };

  componentDidMount() {
    this.fetchCardId();
  }

  fetchCardId = async () => {
    const { data } = await getLastNotificationCardId(INN_RESPONSE_NUMBER);
    this.setState({
      cardId: get(data, 'cardId'),
      responseDate: get(data, 'responseDate'),
      loading: false,
    });
  };

  fetchInnCertificate = async (e) => {
    e.preventDefault();
    const { cardId } = this.state;
    this.setState({ pdfLoading: true });
    const response = await getNotificationResponseByCardId(INN_RESPONSE_NUMBER, cardId);
    if (response.isOk) {
      const blob = new Blob([response.data], { type: 'application/pdf;charset=utf-8' });
      fileSaver.saveAs(blob, 'Свидетельство ИНН.pdf', true);
    }

    this.setState({ pdfLoading: false });
  };

  render() {
    const { hideLink } = this.props;
    const { responseDate, cardId, pdfLoading } = this.state;

    return (
      <DataStatusWrapper isLoading={this.state.loading}>
        <div className={'boo'}>
          {!REACT_CONFIG.REACT_APP_HIDE_INN_CERTIFICATE_REQUEST && !hideLink && (
            <InfoMessage className={'mb-4'}>
              <div>
                Для {cardId && 'повторного'} получения свидетельства ИНН в электронном виде{' '}
                <a href={remotePaths.innCertificateRequest}>
                  заполните заявление о постановке на учет
                </a>
              </div>
            </InfoMessage>
          )}
          {cardId && (
            <div className={styles.InnCertificate}>
              <h2>Свидетельство ИНН</h2>
              <BlueBlock>
                <div className="row align-items-center">
                  <div className="col">
                    <p>Свидетельство о постановке на учет физического лица в налоговом органе</p>
                    <div className={styles.periodText}>
                      {responseDate && (
                        <p>
                          Дата получения:{' '}
                          <span>
                            {moment(responseDate, DateFormats.long_dash).format(DateFormats.long)}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-auto">
                    <Button
                      extraClassName={styles.downloadButton}
                      color={BUTTON_COLORS.WHITE_BLUE}
                      hasWrapper={false}
                      onClick={this.fetchInnCertificate}
                    >
                      {pdfLoading ? <Loading size={'sm'} inline={true} /> : <DownloadIcon />}
                      Скачать
                    </Button>
                  </div>
                </div>
              </BlueBlock>
            </div>
          )}
        </div>
      </DataStatusWrapper>
    );
  }
}

InnCertificate.propTypes = {
  responseDate: PropTypes.string,
  hideLink: PropTypes.bool,
};

export default InnCertificate;
